/**
 * Dependencie
 */
import { sumBy } from 'lodash'

/**
 * Determine if the upload has completed
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const fileUploadCompleted = state => state.progress === 100

/**
 * Determine if the upload was successful
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const uploadSuccessful = state =>
    state.progress === 100 &&
    !state.error &&
    state.mappings.length > 0

/**
 * Get list of all categories and their summed values for reference
 *
 * @param  {Object} state
 * @return {Array}
 */
const importedOpexSummary = (state) => {
    return state.mappings
        .filter(item => item.our_category !== null)
        .reduce((result, item) => {
            let found = result.findIndex(i => i.category === item.our_category)
            if (found > -1) {
                result[found].total += item.amount
                result[found].count++
            } else {
                result.unshift({
                    category: item.our_category,
                    total: item.amount,
                    count: 1
                })
            }

            return result
        }, [])
        .sort((a, b) => {
            let cat1 = state.category_list.indexOf(a.category)
            let cat2 = state.category_list.indexOf(b.category)

            return cat1 < cat2 ? -1 : 1
        })
}

/**
 * Excluded items
 *
 * @param  {Object} state
 * @return {Object}
 */
const excludedTotal = (state) => {
    let excluded = state.mappings.filter(
        item => item.our_category === null
    )

    return sumBy(excluded, 'amount')
}

/**
 * Filtered summary by category key
 *
 * @param  {Object} state
 * @return {Array}
 */
const filteredSummaryByCategory = (state) => {
    let searchTerm = (state.searchTerm || '').toLowerCase()
    return state.mappings
        .filter(item => {
            switch (state.selectedCategory) {
                case '':
                    return true
                case 'Excluded Items':
                    return item.our_category == null
                default:
                    return item.our_category === state.selectedCategory
            }
        })
        .filter(item => {
            let matchableString = (item.name || '').toLowerCase()
            return matchableString.includes(searchTerm)
        })
}

/**
 * Get the total aggregated sum
 *
 * @param  {Object} state
 * @return {Number}
 */
const aggregatedTotal = (state) => sumBy(state.mappings, 'amount')

/**
 * Get the aggregated total from the miscellaneous income items
 *
 * @type {Number}
 */
const miscIncomeTotal = (state) => sumBy(state.miscinc, 'amount')

/**
 * Get the general index for the miscellaneous income dataset
 *
 * @param  {Object} state
 * @return {Array}
 */
const miscIncomeIndex = (state) => {
    if (state.miscinc.length > 0) {
        return state.miscinc[0].parsed_data.index
    }

    return []
}

/**
 * Get the total number of miscellaneous income items
 *
 * @param  {Object} state
 * @return {Number}
 */
const miscIncomeCount = (state) => state.miscinc.length

/**
 * Get the total number of mapped items
 *
 * @param  {Object} state
 * @return {Number}
 */
const opexCount = (state) => state.mappings.length

/**
 * Get the total number of excluded items in the mappings array
 *
 * @param  {Object} state
 * @return {Number}
 */
const excludedItemsCount = (state) =>
    state.mappings.filter(item => item.our_category == null).length

export default {
    opexCount,
    excludedTotal,
    miscIncomeIndex,
    miscIncomeTotal,
    aggregatedTotal,
    miscIncomeCount,
    uploadSuccessful,
    excludedItemsCount,
    fileUploadCompleted,
    importedOpexSummary,
    filteredSummaryByCategory
}



// WEBPACK FOOTER //
// ./src/state/modules/opex-importer/getters.js